export const typography = {
  label: 'text-xs font-bold uppercase tracking-widest',
  micro: 'text-[9px] font-black uppercase tracking-widest',
  microWide: 'text-[10px] font-black uppercase tracking-[0.2em]',
  // WI-3 §3 — the matchup card ramp (size/weight only; callers add color).
  /** Team name — base card size; the hero core may scale up one step in the same family. */
  teamName: 'text-sm font-black',
  /** Numeric status line (countdown / score) — tabular figures avoid reflow on tick. */
  stat: 'text-sm font-black tabular-nums',
  /** "vs" divider between teams — micro caps with extra-wide tracking. */
  vsDivider: 'text-[9px] font-black uppercase tracking-[0.35em]',
  heading: 'text-xl font-black uppercase tracking-tight',
  headingLg: 'text-3xl md:text-4xl font-black uppercase tracking-tighter italic',
  body: 'text-sm text-gray-400',
  bodyStrong: 'text-sm font-medium text-gray-400',
  /** Display — hero headlines (home shell) */
  display: 'text-2xl md:text-3xl font-black uppercase tracking-tight leading-none',
  displayLg: 'text-3xl md:text-5xl font-black uppercase tracking-tighter leading-[0.95]',
  /** Section title inside cards */
  sectionTitle: 'text-base md:text-lg font-black uppercase tracking-tight text-white',
  /** Numeric emphasis — wallet balance, stakes */
  numericLg: 'text-2xl md:text-3xl font-black tabular-nums tracking-tight',
  /** Eyebrow above section titles */
  eyebrow: 'text-[10px] font-black uppercase tracking-[0.2em] text-emerald-400/90',
};
